// extracted by mini-css-extract-plugin
module.exports = {"shopingCard2Root":"ShoppingWidget3_shopingCard2Root__JNBHe","product":"ShoppingWidget3_product__HOT6A","btn":"ShoppingWidget3_btn__UsR1U"};